import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function courseDataReducer(
  state = initialState.courseData,
  action
) {
  switch (action.type) {
    case types.LOADED_COURSE_DATA_SUCCESS:
      return action.courseData;
    default:
      return state;
  }
}
